var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldTimerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63867 1.08008V5.28841H5.84701",
    stroke: "#EE7233",
    strokeWidth: 1.57919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68076 9.49632C1.86719 11.1846 2.6156 12.7611 3.80578 13.9729C4.99597 15.1846 6.55887 15.9612 8.24348 16.1779C9.92809 16.3947 11.6367 16.0389 13.0948 15.1679C14.5529 14.2968 15.676 12.961 16.2836 11.3749C16.8913 9.78881 16.9483 8.04453 16.4454 6.42219C15.9425 4.79984 14.909 3.39356 13.5109 2.42921C12.1127 1.46485 10.431 0.998382 8.7358 1.10471C7.04064 1.21103 5.4304 1.88398 4.16367 3.01548L1.63867 5.28799",
    stroke: "#EE7233",
    strokeWidth: 1.57919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21387 4.44727V8.6556L12.5805 10.3389",
    stroke: "#EE7233",
    strokeWidth: 1.57919,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldTimerIcon);
export default __webpack_public_path__ + "static/media/gold_timer_icon.2e4fa46bfe607d26cd7addf85fe32d55.svg";
export { ForwardRef as ReactComponent };